import React, { ReactNode } from 'react'

import { useCheckSentry } from 'hooks/useCheckSentry/useCheckSentry'

export const CheckSentryController = ({ children }: { children: ReactNode }) => {
    useCheckSentry()

    return <>{children}</>
}
